export default __webpack_public_path__ + "static/media/pexels-rodnae-productions-6647037_2.d8145977.jpg";